<pages-container
  [title]="'main.forumSystemText'"
  [icon]="'text_ad'">
  <div buttons>
    <button mat-raised-button
            class="mat-white-bg"
    (click)="addSystemText()">
      <span>{{ 'main.add' | translate }}</span>
    </button>
  </div>

  <div main-content class="banner-list">
    <div class="system-texts">
      @if (systemTexts().length) {
        @for (st of systemTexts(); track st.id; let i = $index) {
          <div class="system-text-item">
            <div class="system-text-header">
              <div class="system-text-type">{{ st.type }}</div>
              <div class="system-text-actions">
                <button mat-icon-button (click)="editSystemText(st)">
                  <mat-icon >edit</mat-icon>
                </button>
                <button mat-icon-button (click)="deleteSystemText(st)">
                  <mat-icon>delete</mat-icon>
                </button>
              </div>
            </div>
            <div class="system-text-data" [innerHTML]="st.data"></div>
          </div>
        }
      }
    </div>
    @if (!systemTexts()?.length) {
      <div class="no-data-msg">
        <span class="mat-headline-6">{{ 'main.noData' | translate }}</span>
      </div>
    }
  </div>
</pages-container>
